import './App.css';
import Join from './components/Join/Join';
import Hero from './components/Hero/Hero';
import Reasons from './components/Reasons/Reasons';
import Programs from './components/Programs/Programs';
import Plans from './components/Plans/Plans';
import Testimonials from './components/Testimonials/Testimonials';
import Footer from './components/Footer/Footer';
function App() {
  return (
    <div className="App">
        <Hero/> 
        <Programs/> 
        <Reasons />
        <Plans/>
        <Testimonials/>
        <Join/>
        <Footer/>
    </div>
  );
}

export default App;
